import TwoFactorSetupContainer from "components/modules/TwoFactorSetup/TwoFactorSetup";

const TwoFactorSetupPage = () => {
  return <TwoFactorSetupContainer />;
};

export default TwoFactorSetupPage;
